<template>
    <div>
        <div class="content">
            <el-row align="bottom" style="width: 1200px;margin: auto;" type="flex">
                <el-col :span="12" align="left" style="height: 150px;">
                    <div class="title">咨询投诉</div>
                    <!--                <div class="text">了解中创远泰，了解行业前沿资讯</div>-->
                </el-col>
                <el-col :span="12" align="left">
                    <img class="img" src="../../assets/images/consult.png"/>
                </el-col>
            </el-row>
        </div>
        <div class="detailsBox">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>咨询投诉</el-breadcrumb-item>
            </el-breadcrumb>
            <div style="margin-top: 10px;">
                <feedback-list-modal></feedback-list-modal>
            </div>
        </div>
    </div>
</template>

<script>
import feedbackListModal from './modules/feedbackListModal'

export default {
    name: 'Publicity',
    components: {
        feedbackListModal
    },
    data () {
        return {}
    },
    mounted () {
        console.log(this.$route.params)
        if (this.$route.params && this.$route.params.key) {
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
/deep/ img {
    width: 100% !important;
}

.content {
    padding-top: 90px;
    background-color: #31b98b;

    .title {
        font-size: 36px;
        color: #ffffff;
        font-weight: bold;
        line-height: 40px;
        font-style: italic;
    }

    .text {
        font-size: 24px;
        color: #ffffff;
        line-height: 40px;
        margin-top: 20px;
        font-weight: 300;
    }

    .img {
        display: block;
        width: 500px;
    }
}

.detailsBox {
    width: 1200px;
    margin: auto;
    padding: 30px 0;
    .el-menu-vertical-demo {
        margin-top: 30px;
        text-align: left;
        .el-icon-menu {

        }
        .title {
            text-align: left;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/consult/publicity.vue